import React from 'react';
import Box from '@mui/material/Box';
import {
  DataGrid,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from '@mui/x-data-grid';

const getMonthlyRows = data => {
  let rows: any[] = [];
  for (let listing of data) {
    let idx = 0;
    const listingID = listing['listingID'];
    for (let key in listing) {
      if (key.match(/^\d{4}-(0[1-9]|1[0-2])$/)) {
        const month = key;
        const value = listing[key];
        rows.push({
          id: `${listingID}-${idx}`,
          'Airbnb Property ID': listingID,
          Month: month,
          ADR: value?.['ADR'],
          'Occupancy Rate': value?.['Occupancy Rate'],
          Revenue: value?.Revenue,
          'Available Days': value?.['Available Days'],
          'Booked Days': value?.['Booked Days'],
        });
        idx = idx + 1;
      }
    }
  }
  return rows;
};

const getYearlyRows = data => {
  let rows: any[] = [];
  for (let listing of data) {
    for (let key in listing) {
      if (key.includes('Year')) {
        const year = key;
        const value = listing[key];
        rows.push({
          id: `${listing.listingID}`,
          'Airbnb Property ID': listing.listingID,
          Year: year,
          ADR: value['ADR'],
          'Occupancy Rate': value['Occupancy Rate'],
          Revenue: value.Revenue,
          'Available Days': value['Available Days'],
          'Booked Days': value['Booked Days'],
        });
      }
    }
  }
  return rows;
};

const SamplePerformanceTable = ({ data, granularity, marketName }) => {
  const columns = [
    { field: 'Airbnb Property ID', headerName: 'Airbnb Property ID', width: 150 },
    {
      field: granularity == 'monthly' ? 'Month' : 'Year',
      headerName: granularity == 'monthly' ? 'Month' : 'Year',
      width: 200,
    },
    { field: 'ADR', headerName: 'ADR (USD)', width: 100 },
    { field: 'Occupancy Rate', headerName: 'Occupancy Rate (%)', width: 150 },
    { field: 'Revenue', headerName: 'Revenue (USD)', width: 150 },
    { field: 'Available Days', headerName: 'Available Days', width: 150 },
    { field: 'Booked Days', headerName: 'Booked Days', width: 150 },
  ];

  const rows = granularity == 'monthly' ? getMonthlyRows(data) : getYearlyRows(data);

  const CustomToolbar = ({ fileName }) => {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport csvOptions={{ fileName: fileName, utf8WithBom: true }} />
      </GridToolbarContainer>
    );
  };

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableSelectionOnClick
        components={{
          Toolbar: props => (
            <CustomToolbar
              {...props}
              fileName={`Sample: ${marketName} Performance data - Airbtics.csv`}
            />
          ),
        }}
      />
    </Box>
  );
};

export default SamplePerformanceTable;
